import { createFileRoute } from "@tanstack/react-router";
import GrandparentWatchingFamilyStruggle from "@/pages/articles/GrandparentWatchingFamilyStruggle";
export const Route = createFileRoute(
  "/grandparent-watching-your-family-struggle-youre-not-helpless",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Grandparent Watching Your Family Struggle | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Watching your family struggle with depression is hard. Learn how to help and what treatment options exist for your loved ones in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Grandparent Watching Your Family Struggle | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Watching your family struggle with depression is hard. Learn how to help and what treatment options exist for your loved ones in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/grandparent-watching-your-family-struggle-youre-not-helpless",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/grandparent-watching-your-family-struggle-youre-not-helpless",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <GrandparentWatchingFamilyStruggle />;
}
